// components/FAQSection.jsx

import React, { useState } from 'react';

const faqData = [
  {
    question: "What is Brainy Buddy?",
    answer: "BrainyBuddy is your all-in-one, gamified brain-training platform designed to make learning irresistibly fun and effective. With a suite of interactive games—like Memory Sprint, Synonym Sync, and Focus Challenges—plus your AI tutor Buddy Bot built right in, BrainyBuddy adapts to your skill level, tracks your progress, and rewards every milestone. Whether you’re sharpening your concentration, boosting vocabulary, or tackling math puzzles, BrainyBuddy turns practice into play. 👉 Dive in today and unlock your brain’s full potential!"
  },
    {
    question: "What is Buddy Bot?",
    answer: "Buddy Bot is your personal AI-powered learning companion built right into BrainyBuddy. Whether you’re a student, teacher, or parent, Buddy Bot listens, remembers your progress, and explains any concept—big or small—in clear, friendly language (even in Tamil!). It’s like having a wise tutor, playful quiz master, and supportive coach all rolled into one. 👉 Try Buddy Bot now and discover how fun—and effective—learning can be!"
  },
  {
    question: "What do I get with a Pro Membership?",
    answer: "Pro members get access to maximum daily game plays, unlock all features, earn badges, track streaks, and join special Leaderboard."
  },
  {
    question: "How can I upgrade to Pro?",
    answer: "You can upgrade by contacting us via WhatsApp or email on the Contact page. We'll activate your account based on the plan you choose."
  },
  {
    question: "Can I track my child’s progress?",
    answer: "Yes! The platform tracks streaks, scores, earned badges, and unlocks levels to help kids (and parents) see their progress."
  },
  {
    question: "How often are new games added?",
    answer: "We continuously work on adding new games and challenges to keep the learning fresh and exciting!"
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white py-12 px-4 max-w-3xl mx-auto rounded-xl shadow-lg mt-10">
      <h2 className="text-3xl font-bold text-center text-purple-700 mb-8">Frequently Asked Questions</h2>

      {faqData.map((faq, index) => (
        <div key={index} className="mb-4 border-b pb-4">
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full text-left text-lg font-semibold text-purple-800 focus:outline-none"
          >
            {faq.question}
          </button>
          {openIndex === index && (
            <p className="text-gray-600 mt-2 pl-4">{faq.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
}
